import { render, staticRenderFns } from "./WebBackground.vue?vue&type=template&id=159810de&scoped=true"
import script from "./WebBackground.vue?vue&type=script&lang=js"
export * from "./WebBackground.vue?vue&type=script&lang=js"
import style0 from "./WebBackground.vue?vue&type=style&index=0&id=159810de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159810de",
  null
  
)

export default component.exports